var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"monogram",class:_vm.monogramStyles},[(_vm.user.avatar && !_vm.loadError)?_c('img',{attrs:{"src":_vm.user.avatar ? _vm.apiBase + '/avatar/' + _vm.user.avatar : ''},on:{"error":function($event){_vm.loadError = true}}}):_c('span',[_vm._v(" "+_vm._s(_vm.user.firstname && _vm.user.firstname[0].toUpperCase())+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }